import script from "./DeviceCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceCheck.vue?vue&type=script&setup=true&lang=js"

import "./DeviceCheck.vue?vue&type=style&index=0&id=12576a02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12576a02"]])

export default __exports__